// MoreSection.tsx
import Typography from "@mui/material/Typography";
import "./MoreSection.css";
import MoreButton from "../MoreButton";

const MoreSection = () => {

  const handleOpenPdf = () => {
    const pdfPath = "https://dotmedica.com/assets/DOTMEDICA%20Company%20Profile%2002.pdf";
    window.open(pdfPath, "_blank"); // Open the PDF in a new tab
  };


  return (
    <div className="more-section">
      <div className="more-content">
        <Typography variant="body1" className="description">
          DOTMEDICA stands as a prominent occupational medical center, both in
          the Middle East and globally.
        </Typography>
        <MoreButton buttonText="Company Profile" onClick={handleOpenPdf} />
      </div>
    </div>
  );
};

export default MoreSection;
